import(/* webpackMode: "eager" */ "/usr/src/app/frontend/src/app/(editor)/n/[noteId]/page.tsx");
